export default __webpack_public_path__ + "static/media/userGray.c63fe289.png";